import React from "react";
import { arrayOf, number, shape, string } from "prop-types";

import BaseTable from "components/tables/Base";
import ColumnHeader from "components/tables/ColumnHeader";
import { getTokenEarnedDollarAmount } from "features/donations/utils";

function DonationsByAnimaticTable({ animaticData }) {
  /** Show aggregated doantions grouped by animatic. */

  function renderRows() {
    return animaticData.map(({ id, title, amount }) => (
      <tr key={id}>
        <td>{title}</td>
        <td>{getTokenEarnedDollarAmount(amount)}</td>
      </tr>
    ));
  }

  return (
    <BaseTable>
      <thead>
        <tr>
          <ColumnHeader>Title</ColumnHeader>
          <ColumnHeader>Amount</ColumnHeader>
        </tr>
      </thead>
      <tbody>{renderRows()}</tbody>
    </BaseTable>
  );
}

DonationsByAnimaticTable.propTypes = {
  series: arrayOf(
    shape({
      id: number.isRequired,
      title: string.isRequired,
      amount: number.isRequired,
    }).isRequired
  ).isRequired,
};

export default DonationsByAnimaticTable;
